// components/townlitOfficial/support/WaysToSupport.tsx

"use client";

import Link from "next/link";
import { HeartHandshake, HandCoins, Handshake } from "lucide-react";
import "./WaysToSupport.css";

const WaysToSupport = () => {
  return (
    <section className="support-container">

      <div className="official-title-container">
        <h2 className="official-title">
          Ways to Support
          <span className="official-brand-name">TownLIT</span>
        </h2>
        <p className="util-text-hint">
          Your support becomes the spark that carries His light to the broken, the forgotten — places still longing for hope.
        </p>
      </div>

      <div className="support-list">
        <Link href="/townlit-official/prayer" className="support-item">
          <HeartHandshake className="support-icon" aria-hidden="true" />
          <div className="support-text">
            <h5 className="support-heading">Pray for Us</h5>
            <p className="support-desc">
              Send us your prayer or let us know you&apos;re praying with us.
            </p>
          </div>
        </Link>

        <Link href="/townlit-official/donate" className="support-item">
          <HandCoins className="support-icon" aria-hidden="true" />
          <div className="support-text">
            <h5 className="support-heading">Make a Donation</h5>
            <p className="support-desc">
              Support our platform and help us grow the Kingdom together.
            </p>
          </div>
        </Link>

        <Link href="/townlit-official/collaborate" className="support-item">
          <Handshake className="support-icon" aria-hidden="true" />
          <div className="support-text">
            <h5 className="support-heading">Collaborate</h5>
            <p className="support-desc">
              Interested in volunteering or partnering with us? Let&apos;s connect.
            </p>
          </div>
        </Link>
      </div>
    </section>
  );
};

export default WaysToSupport;
